import React from "react";
import { Button } from "primereact/button";

interface DriverToolbarProps {
  onAdd: () => void;
  onDeleteSelected: () => void;
  onExport: () => void;
  hasSelection: boolean;
}

export const DriverToolbar: React.FC<DriverToolbarProps> = ({
  onAdd,
  onDeleteSelected,
  onExport,
  hasSelection,
}) => {
  const leftContents = (
    <>
      <h1 className="text-2xl sm:text-3xl font-bold mb-2 sm:mb-0">Gestion des Chauffeurs</h1>
      <Button
        label="Exporter"
        icon="pi pi-upload"
        iconPos="right"
        className=" rounded-xl px-8 bg-white ring-2 ring-primary border-none text-primary text-md font-medium font-sans hover:-translate-y-1 transition-all ease-in-out duration-300 hidden"
        onClick={onExport}
        tooltip="Exporter la liste des chauffeurs"
        tooltipOptions={{
          position: "top",
          updateDelay: 0,
          className: "font-sans text-center -translate-y-3",
        }}
      />
    </>
  );

  const rightContents = (
    <>
      <Button
        label="Supprimer"
        icon="pi pi-trash"
        iconPos="right"
        className="me-2 rounded-xl bg-red-600 border-none font-sans text-white text-sm sm:text-md font-medium py-2 px-4 sm:py-3 sm:px-8 hover:-translate-y-1 transition-all ease-in-out duration-300"
        onClick={onDeleteSelected}
        disabled={!hasSelection}
      />
      <Button
        label="Nouveau"
        icon="pi pi-plus"
        iconPos="right"
        className="rounded-xl bg-primary border-none font-sans text-white text-sm sm:text-md font-medium py-2 px-4 sm:py-3 sm:px-8 hover:-translate-y-1 transition-all ease-in-out duration-300"
        onClick={onAdd}
        tooltip="Ajouter un nouveau chauffeur"
        tooltipOptions={{
          position: "top",
          updateDelay: 0,
          className: "font-sans text-center -translate-y-3",
        }}
      />
    </>
  );

  return (
    <div className="w-full flex flex-col sm:flex-row sm:items-center sm:justify-between py-2 space-y-2 sm:space-y-0">
      <div className="flex flex-col sm:flex-row sm:items-center sm:space-x-4">
        {leftContents}
      </div>
      <div className="flex items-center space-x-2">
        {rightContents}
      </div>
    </div>
  );
};
